// src/index.ts
import ContentstackLivePreviewHOC from "./contentstack-live-preview-HOC.js";
var LightLivePreviewHoC = {
  init() {
  },
  onLiveEdit() {
  },
  onEntryChange(callback) {
    return callback();
  },
  get hash() {
    return "";
  },
  setConfigFromParams() {
  }
};
var ContentstackLivePreview = process.env.PURGE_PREVIEW_SDK || process.env.REACT_APP_PURGE_PREVIEW_SDK ? LightLivePreviewHoC : ContentstackLivePreviewHOC;
var src_default = ContentstackLivePreview;
export {
  ContentstackLivePreview,
  src_default as default
};
//# sourceMappingURL=index.js.map